import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import { MenuList, MenuItem as MaterialMenuItem } from '@material-ui/core';

import { Dispatch } from '../../../../configs/store';
import Icon from '../../../Icon/Icon';
import DropDown from '../../../DropDown/DropDown';

interface MenuItemProps {
  type: string,
  items?: { value: string, label: string }[],
  selected?: string
}

function MenuItem({ type, items = [], selected = '' }: MenuItemProps) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch<Dispatch>();

  const selectedItem = _.find(items, i => i.value === selected);

  const openMenu = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    e.preventDefault();

    setOpen(true);
  };

  const closeMenu = (menu: string, value: string = '') => (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    e.preventDefault();

    if (value) {
      switch (menu) {
        case 'odds':
          dispatch.odds.updateOddsType(value);
          break;

        case 'language':
          dispatch.odds.updateLanguage(value);
          break;

        case 'timezone':
          dispatch.odds.updateTimezone(value);
          break;

        default:
          break;
      }
    }

    setOpen(false);
  };

  return (
    <div
      className={
        classNames({
          'top-menu__item': true,
          'top-menu__item--has-option': items && items.length > 0 && selected
        })
      }
    >
      <DropDown
        value={
          items && items.length >= 0 && selected ?
            <span
              className="dropdown dropdown__top--value"
              title={ selectedItem && selectedItem.label }
            >
              <span className="dropdown dropdown__top--label">{ type }:</span> &nbsp;{ selectedItem && selectedItem.label }
            </span>
            :
            <span className="dropdown dropdown__top--label">{ type }</span>
        }
        className="dropdown__top"
        iconMargin={ true }
        IconComponent={ <Icon icon="arrow" /> }
        openMenu={ openMenu }
        closeMenu={ closeMenu(type) }
        open={ open }
      >
        <MenuList className="top-menu__sub-menu" autoFocusItem={ true }>
          {
            items && _.map(items, (item, index) => {
              return (
                <MaterialMenuItem
                  className="top-menu__sub-menu__item"
                  key={ index }
                  onClick={ closeMenu(type, item.value) }
                  selected={ item.value === selected }
                >
                  <span className="top-menu__sub-menu__item-label">{ item.label }</span>
                </MaterialMenuItem>
              );
            })
          }
        </MenuList>
      </DropDown>
    </div>
  );
}

export default React.memo(MenuItem);
